// useDataCounts.js
import { useMemo } from 'react';
import { NOT_SELECTED } from '../Container/CisUpload/fileTempates';
import { storeNameList } from '../Container/utils';
import { findKeyByValue } from '../components/AdminDashboard/utils';

const calculateARPercentage = (ARateList = []) => {
  let actWithoutAcc = 0;
  let hupWithoutAcc = 0;

  if (ARateList?.length > 0) {
    ARateList.forEach((obj) => {
      const { aaData, connectionType, simNumber } = obj;
      const { cost, msrp, discount } = aaData;
      if (
        cost === 0 &&
        msrp === 0 &&
        discount === 0 &&
        (connectionType === 'Postpaid' || connectionType === 'Prepaid') &&
        simNumber !== 'N/A'
      ) {
        actWithoutAcc++;
      } else if (
        cost === 0 &&
        msrp === 0 &&
        discount === 0 &&
        (connectionType === 'Postpaid' || connectionType === 'Prepaid') &&
        simNumber === 'N/A'
      ) {
        hupWithoutAcc++;
      }
    });
  }

  return { actWithoutAcc, hupWithoutAcc };
};

const filterARList = (ARateList, currentfilter) => {
  let filterARList = ARateList;

  if (currentfilter?.length === 2) {
    const emailPrefix = currentfilter[0] + '@vyadom.com';
    if (currentfilter[0] && currentfilter[1] === undefined) {
      filterARList = ARateList.filter((item) => item?.user === emailPrefix);
    } else if (currentfilter[1] && currentfilter[0] === '') {
      const key = findKeyByValue(storeNameList, currentfilter[1]);
      filterARList = ARateList.filter((item) => item?.storeInvoice === key);
    } else if (currentfilter[1] && currentfilter[0]) {
      const key = findKeyByValue(storeNameList, currentfilter[1]);
      filterARList = ARateList.filter(
        (item) => item?.storeInvoice === key && item.user === emailPrefix,
      );
    }
  }
  return filterARList;
};

const useTargetsCounts = (employeeData, eventCisData, ARList, currentfilter) => {
  let data = useMemo(() => {
    const counts = {
      postCount: 0,
      preCount: 0,
      hupCount: 0,
      autopayCount: 0,
      withDeviceCount: 0,
      pppCount: 0,
      addonsCount: 0,
      appleCareCount: 0,
      appleCareCountPlus: 0,
      pppPlusCount: 0,
      pppTotalCount: 0,
      ACT_AR: 0,
      HUP_AR: 0,
      Total_AR: 0,
      Total_ACT: 0,
    };

    employeeData?.forEach((item) => {
      if (new Date(item.tenderedDate) > new Date('2025-04-14')) {
        if (item?.phoneProtectionPlan !== 'N/A' && item.phoneProtectionPlan !== NOT_SELECTED) {
          if (item.phoneProtectionPlan?.includes('Plus')) {
            //phone protection plus
            counts.pppPlusCount++;
          } else {
            counts.pppCount++;
          }
          counts.pppTotalCount++;
        }
      } else {
        if (
          item.phoneProtectionPlan === 'Accepted' ||
          item.addons.includes('Phone Protection Plan') ||
          item.phoneProtectionPlan?.startsWith('s $15.00') ||
          item.phoneProtectionPlan?.startsWith('s featuring') ||
          item.phoneProtectionPlan?.startsWith('.00')
        ) {
          counts.pppCount++;
        }
      }
      if (item?.appleCare !== 'N/A' && item.appleCare !== NOT_SELECTED) {
        if (item.appleCare?.includes('Plus')) {
          //phone protection plus
          counts.appleCareCountPlus++;
        } else {
          counts.appleCareCount++;
        }
      }

      // if (
      //   (item.phoneProtectionPlan?.includes('Plus'))
      // ) {
      //   //phone protection plus
      //   counts.pppPlusCount++;
      // }

      // if (
      //   item.addons.includes('AppleCare') ||
      //   item.phoneProtectionPlan?.startsWith('turing AppleCare')
      // ) {
      //   counts.appleCareCount++;
      //   counts.pppTotalCount++;
      // }
      if (item.simNumber !== 'N/A' && item.connectionType === 'Postpaid') {
        counts.postCount++;
      }
      if (item.connectionType === 'Prepaid') {
        counts.preCount++;
      }
      if (item.simNumber === 'N/A' && item.imei !== 'N/A') {
        counts.hupCount++;
      }
      if (
        item.autoPayPre === 'YES' ||
        item.autoPayPost === 'YES' ||
        item.autoPayPre === 'successfully' ||
        item.autoPayPre === 'successfully for Pre - Authorized Payments' ||
        item.autoPayPost === 'successfully for Pre - Authorized Payments'
      ) {
        counts.autopayCount++;
      }
      if (new Date(item.tenderedDate) > new Date('2025-04-14')) {
        if (
          item.initialCredit &&
          item.simNumber !== 'N/A' &&
          item.imei !== 'N/A' &&
          !item.imei?.startsWith('N/A')
        ) {
          counts.withDeviceCount++;
        }
      } else {
        if (item.simNumber !== 'N/A' && item.imei !== 'N/A' && !item.imei?.startsWith('N/A')) {
          counts.withDeviceCount++;
        }
      }
      if (item.addons !== '' && item.addons !== 'N/A') {
        counts.addonsCount++;
      }
    });

    return counts;
  }, [employeeData]);

  const dataEvent = useMemo(() => {
    const counts = {
      postCount: 0,
      preCount: 0,
      hupCount: 0,
      autopayCount: 0,
      withDeviceCount: 0,
      pppCount: 0,
      addonsCount: 0,
      appleCareCount: 0,
      appleCareCountPlus:0,
      pppPlusCount: 0,
      pppTotalCount: 0,
    };

    eventCisData?.forEach((item) => {
      if (new Date(item.tenderedDate) > new Date('2025-04-14')) {
        if (item?.phoneProtectionPlan !== 'N/A' && item.phoneProtectionPlan !== NOT_SELECTED) {
          if (item.phoneProtectionPlan?.includes('Plus')) {
            //phone protection plus
            counts.pppPlusCount++;
          } else {
            counts.pppCount++;
          }
          counts.pppTotalCount++;
        }
      } else {
        if (
          item.phoneProtectionPlan === 'Accepted' ||
          item.addons.includes('Phone Protection Plan') ||
          item.phoneProtectionPlan?.startsWith('s $15.00') ||
          item.phoneProtectionPlan?.startsWith('s featuring') ||
          item.phoneProtectionPlan?.startsWith('.00')
        ) {
          counts.pppCount++;
        }
      }
      if (item.appleCare &&item?.appleCare !== 'N/A' && item.appleCare !== NOT_SELECTED) {
        if (item.appleCare?.includes('Plus')) {
          //phone protection plus
          counts.appleCareCountPlus++;
        } else {
          counts.appleCareCount++;
        }
      }

      /*if (item.addons.includes('Plus')) {
        //phone protection plus
        counts.pppPlusCount++;
      }*/

      if (item.phoneProtectionPlan?.includes('Plus')) {
        //phone protection plus
        counts.pppPlusCount++;
      }

      // if (
      //   item.addons.includes('AppleCare') ||
      //   item.phoneProtectionPlan?.startsWith('turing AppleCare')
      // ) {
      //   counts.appleCareCount++;
      //   counts.pppTotalCount++;
      // }
      if (item.simNumber !== 'N/A' && item.connectionType === 'Postpaid') {
        counts.postCount++;
      }
      if (item.connectionType === 'Prepaid') {
        counts.preCount++;
      }
      if (item.simNumber === 'N/A' && item.imei !== 'N/A') {
        counts.hupCount++;
      }
      if (
        item.autoPayPre === 'YES' ||
        item.autoPayPost === 'YES' ||
        item.autoPayPre === 'successfully' ||
        item.autoPayPre === 'successfully for Pre - Authorized Payments' ||
        item.autoPayPost === 'successfully for Pre - Authorized Payments'
      ) {
        counts.autopayCount++;
      }
      if (new Date(item.tenderedDate) > new Date('2025-04-14')) {
        if (
          item.initialCredit &&
          item.simNumber !== 'N/A' &&
          item.imei !== 'N/A' &&
          !item.imei?.startsWith('N/A')
        ) {
          counts.withDeviceCount++;
        }
      } else {
        if (item.simNumber !== 'N/A' && item.imei !== 'N/A' && !item.imei?.startsWith('N/A')) {
          counts.withDeviceCount++;
        }
      }
      if (item.addons !== '') {
        counts.addonsCount++;
      }
    });

    return counts;
  }, [eventCisData]);

  let { actWithoutAcc, hupWithoutAcc } = calculateARPercentage(filterARList(ARList, currentfilter));

  if (employeeData?.length > 0 && ARList?.length > 0) {
    let Total_ACT = data.postCount + data.preCount;
    let ACT_AR = ((Total_ACT - actWithoutAcc) / Total_ACT) * 100 || 0;
    let HUP_AR = ((data?.hupCount - hupWithoutAcc) / data.hupCount) * 100 || 0;
    let Total_AR =
      ((Total_ACT - actWithoutAcc + (data?.hupCount - hupWithoutAcc)) /
        (Total_ACT + data.hupCount)) *
        100 || 0;

    data = { ...data, ACT_AR, HUP_AR, Total_AR, Total_ACT };
  }
  return { data, dataEvent };
};

export default useTargetsCounts;
